import { render, staticRenderFns } from "./OrderWarning.vue?vue&type=template&id=53c34992&scoped=true&"
import script from "./OrderWarning.vue?vue&type=script&lang=js&"
export * from "./OrderWarning.vue?vue&type=script&lang=js&"
import style0 from "./OrderWarning.vue?vue&type=style&index=0&id=53c34992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c34992",
  null
  
)

export default component.exports